module.exports = __webpack_public_path__ + "img/2.84f5ef99.jpg";